export enum TypeaheadProviders {
  CUSTOMER = 'CUSTOMER'
}
